import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import { motion } from "framer-motion";
import Image from "next/image";
import UseAnimationIos from "@/pages/api/UseAnimationIos";
import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";

const UserCard = ({ name, position, content, service }) => (
  <div className="relative max-h-[20rem] sm:min-h-[20rem] user-card-style sm:w-[15rem] bg-white px-[16px] py-[12px] my-1 ">
  {/*}  <p style={{ lineHeight: "20px" }} className="font-bold text-[16px] ">
      {" "}
      {service ? service : "Logo Designing and Branding "}{" "}
    </p> */}
    <p style={{ fontWeight: 300 }} className="pt-2 text-[14px]">
      {content
        ? content
        : `"Our collaboration with Techcelerant for logo and design services has been exceptional. The creative team took the time to deeply understand our brand vision and crafted a unique and memorable logo that perfectly represents our company's identity.” `}
    </p>

    <div className="flex flex-col sm:absolute sm:bottom-1">
      <p className="pt-2">{/*Name &nbsp;*/} {name ? name : "Lorem ispum"}</p>
  {/*}    <p>Position &nbsp; {position ? position : "lorem ispum"} </p> */}
      <Image
        width={50}
        height={50}
        className="pt-2 w-[70%] h-auto"
        alt="all review stars together"
        src="/assets/testimonials/stars-users.svg"
      />
    </div>
  </div>
);

const Starts = () => (
  <span className="flex items-center gap-3 pt-7 justify-start">
    <Image
      width={50}
      height={50}
      alt="review stars"
      src="/assets/testimonials/testimonial-stars.svg"
    />
    <Image
      width={50}
      height={50}
      alt="review stars"
      src="/assets/testimonials/testimonial-stars.svg"
    />
    <Image
      width={50}
      height={50}
      alt="review stars"
      src="/assets/testimonials/testimonial-stars.svg"
    />
    <Image
      width={50}
      height={50}
      alt="review stars"
      src="/assets/testimonials/testimonial-stars.svg"
    />
    <Image
      width={50}
      height={50}
      alt="review stars"
      src="/assets/testimonials/testimonial-stars.svg"
    />
  </span>
);

const TestSection = ({ testData }) => {
  const [isOnScreen, setOnScreen] = useState(false);
  const ref = useRef();
  UseAnimationIos(ref, setOnScreen);

  const { data, t2_first_heading, t2_first_paragraph } = testData;

  return (
    <motion.div ref={ref} className="">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} lg={5} xl={6}>
          <div>
            <div className="flex flex-col items-center sm:items-start max-w-[40rem] m-auto">
              <h2
                className={` max-w-[85%] text-white text-[30px] ${GilroyFontLight.className} `}
                dangerouslySetInnerHTML={{ __html: t2_first_heading }}
              ></h2>
              <Starts />
              <h3
                style={{ fontWeight: 300 }}
                className={` text-white pt-[2rem] pl-[2rem] sm:pl-0 ${GilroyFontDark.className} `}
              >
                {t2_first_paragraph}
              </h3> 
            </div>
            <div className="pt-[2rem]  sm:flex space-y-[8px] sm:space-y-0 gap-2 items-start pl-[2rem] sm:pl-0 flex flex-col sm:flex-row justify-center sm:items-center xl:justify-end">
              <div className="sm:flex space-y-5 sm:space-y-0 gap-2">
                {/* <Image   width={50} height={50} className="hidden 2xl:block max-h-[20rem]" alt='styling shade' src='/assets/testimonials/testimonial_style_card.webp' /> */}
                <div className=" space-y-4">
                <UserCard
                  name={data[20].name}
                  position={data[20].position}
                  content={data[20].review}
                  service={data[20].service}
                />
                <UserCard
                  name={data[21].name}
                  position={data[21].position}
                  content={data[21].review}
                  service={data[21].service}
                />
                                <UserCard
                  name={data[22].name}
                  position={data[22].position}
                  content={data[22].review}
                  service={data[22].service}
                />
                <UserCard
                  name={data[23].name}
                  position={data[23].position}
                  content={data[23].review}
                  service={data[23].service}
                />
                </div>
                <div className=" space-y-4">
                <UserCard
                  name={data[0].name}
                  position={data[0].position}
                  content={data[0].review}
                  service={data[0].service}
                />
                <UserCard
                  name={data[11].name}
                  position={data[11].position}
                  content={data[11].review}
                  service={data[11].service}
                />
                                <UserCard
                  name={data[15].name}
                  position={data[15].position}
                  content={data[15].review}
                  service={data[15].service}
                />
                <UserCard
                  name={data[18].name}
                  position={data[18].position}
                  content={data[18].review}
                  service={data[18].service}
                />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                
                <UserCard
                  name={data[1].name}
                  position={data[1].position}
                  content={data[1].review}
                  service={data[1].service}
                />
                <UserCard
                  name={data[2].name}
                  position={data[2].position}
                  content={data[2].review}
                  service={data[2].service}
                />
                <UserCard
                  name={data[12].name}
                  position={data[12].position}
                  content={data[12].review}
                  service={data[12].service}
                />
                <UserCard
                  name={data[19].name}
                  position={data[19].position}
                  content={data[19].review}
                  service={data[19].service}
                />
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} lg={7} xl={6}>
          <div className="flex flex-col pl-[2rem] sm:pl-0  sm:items-center xl:items-start">
            <div className="pt-[2rem] sm:flex items-center  gap-2 xl:items-start">
              <div className="flex flex-col gap-2 sm:mt-10">
                <UserCard
                  name={data[3].name}
                  position={data[3].position}
                  content={data[3].review}
                  service={data[3].service}
                />
                <UserCard
                  name={data[4].name}
                  position={data[4].position}
                  content={data[4].review}
                  service={data[4].service}
                />
                <UserCard
                  name={data[5].name}
                  position={data[5].position}
                  content={data[5].review}
                  service={data[5].service}
                />
                <UserCard
                  name={data[13].name}
                  position={data[13].position}
                  content={data[13].review}
                  service={data[13].service}
                />
                
              </div>
              <div className="flex flex-col gap-2 sm:mt-40">
                <UserCard
                  name={data[6].name}
                  position={data[6].position}
                  content={data[6].review}
                  service={data[6].service}
                />
                <UserCard
                  name={data[7].name}
                  position={data[7].position}
                  content={data[7].review}
                  service={data[7].service}
                />
                <UserCard
                  name={data[8].name}
                  position={data[8].position}
                  content={data[8].review}
                  service={data[8].service}
                />
                <UserCard
                  name={data[16].name}
                  position={data[16].position}
                  content={data[16].review}
                  service={data[16].service}
                />
              </div>
              <div className="flex flex-col gap-2 sm:mt-60">
                
                <UserCard
                  name={data[9].name}
                  position={data[9].position}
                  content={data[9].review}
                  service={data[9].service}
                />
                <UserCard
                  name={data[10].name}
                  position={data[10].position}
                  content={data[10].review}
                  service={data[10].service}
                />
                                <UserCard
                  name={data[14].name}
                  position={data[14].position}
                  content={data[14].review}
                  service={data[14].service}
                />
                <UserCard
                  name={data[17].name}
                  position={data[17].position}
                  content={data[17].review}
                  service={data[17].service}
                />
                
               
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </motion.div>
  );
};

export default TestSection;
